import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { UiSpinner } from 'src/components/UI/Spinner';

type Props = {
  useText?: boolean;
  transparent?: boolean;
};

export const UiFullScreenLoader: React.FC<Props> = ({ useText = true, transparent = false }: Props) => {
  const { t } = useTranslation();

  return (
    <div
      className={classNames('fullscreen-loading-container', {
        'transparent-background': transparent,
      })}
      id={transparent ? 'fullScreenTransparentBackgroundProgressCircle' : 'fullScreenProgressCircle'}
    >
      {useText && <h3>{t('common.loader.text')}</h3>}
      <UiSpinner big />
    </div>
  );
};
